/* ══════════════════════════════════════════════════════════════════════════
   SESSION-ÁTVÉTEL A LANDINGRŐL — 1. lépés: a token levétele a címsorból
   ─────────────────────────────────────────────────────────────────────────
   A landing így nyitja a terminált (landing src/terminal.js):
     /#w3k_handoff=1&w3k_at=<access_token>&w3k_rt=<refresh_token>
   Ugyanaz a formátum, mint a terminál → landing és a landing → egyetem
   irányban. A `w3k_` kulcsokat a supabase-js nem hiszi saját implicit-grant
   visszatérésének.

   Ennek a modulnak NINCS importja, és az src/index.js ELSŐ importja: a token
   még a Supabase-kliens létrejötte és az első render előtt lekerül a
   címsorból, így egyetlen saját kérés se viszi Refererként, és a
   detectSessionInUrl se látja. Ezután csak ebben a modulban él, amíg a
   sessionHandoff.js fel nem használja. Tokent SOHA ne logolj.

   ÁTMENETI (2026-10-10-ig): a régi `?access_token=…&refresh_token=…` query
   formátumot is elfogadjuk, hogy egy még régi landing-fülből érkező link se
   veszítse el a sessiont — de azt is azonnal takarítjuk. A session_handoff_*
   események `variant` mezője mutatja, mikor fogyott el a `legacy_query`
   forgalom; utána ez az ág törölhető.
   ══════════════════════════════════════════════════════════════════════════ */

let captured = null;

function cleanUrl() {
  try {
    window.history.replaceState(window.history.state, '', window.location.pathname);
  } catch (e) { /* némán */ }
}

function capture() {
  let hash = window.location.hash || '';
  if (hash.startsWith('#')) hash = hash.slice(1);
  const h = new URLSearchParams(hash);
  if (h.get('w3k_handoff') === '1') {
    cleanUrl();
    const access_token = h.get('w3k_at');
    const refresh_token = h.get('w3k_rt');
    if (access_token && refresh_token) captured = { access_token, refresh_token, variant: 'w3k' };
    return;
  }

  // ÁTMENETI: a régi query-formátum (törlendő 2026-10-10 után). Ennél a token
  // már a dokumentum-kérés URL-jében volt, és az első saját erőforrások
  // (main.js, main.css) Refererjébe is bekerül, mert a böngésző ezeket a JS
  // futása előtt kéri le — ugyanabba a Netlify-naplóba, ahol a kérés URL-je
  // már szerepel. Ezt csak a küldő oldal (landing: hash) szünteti meg.
  const q = new URLSearchParams(window.location.search);
  if (q.has('access_token') || q.has('refresh_token')) {
    cleanUrl();
    const access_token = q.get('access_token');
    const refresh_token = q.get('refresh_token');
    if (access_token && refresh_token) captured = { access_token, refresh_token, variant: 'legacy_query' };
  }
}

capture();

/* A kiolvasott tokenek, egyszer; a további hívások null-t kapnak. */
export function takeHandoff() {
  const c = captured;
  captured = null;
  return c;
}
